import OnboardingWizard from './OnboardingWizard'

export default function OnboardingPage() {
  return <OnboardingWizard />
}
